module.exports = __webpack_public_path__ + "img/ios-qrcode.a391cdb2.png";